import { render, staticRenderFns } from "./ProfileCountRenderer.vue?vue&type=template&id=630483f2&scoped=true&"
import script from "./ProfileCountRenderer.vue?vue&type=script&lang=js&"
export * from "./ProfileCountRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630483f2",
  null
  
)

export default component.exports